import axios from "axios";

import {
  isEmpty,
  toastError,
  toastSuccess,
} from "../../../utils/helpers/helper";
import {
  EMAIL_TEMPLATE_FAIL,
  EMAIL_TEMPLATE_REQUEST,
  EMAIL_TEMPLATE_SUCCESS,
} from "../../constants/emailTemplateConstants";

export const listEmailTemplates =
  (params = "PB") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: EMAIL_TEMPLATE_REQUEST,
      });
      let { access } = getState();
      let headers = {
        "content-type": "application/json",
      };
      if (isEmpty(access)) {
        access = JSON.parse(localStorage.getItem("token"));
      }
      if (access) {
        headers = {
          "content-type": "application/json",
          Authorization: `Bearer ${access}`,
        };
      }
      const config = {
        // params,
        // paramsSerializer: function paramsSerializer(params) {
        //   // "Hide" the `answer` param
        //   return Object.entries(Object.assign({}, params))
        //     .map(([key, value]) => `${key}=${value}`)
        //     .join("&");
        // },
        headers,
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/email-templates?type=${params}`,
        config
      );

      // const result = Object.values(
      //   data.reduce((acc, obj) => ({ ...acc, [obj.id]: obj }), {})
      // );

      dispatch({
        type: EMAIL_TEMPLATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMAIL_TEMPLATE_FAIL,
        payload: error,
      });
    }
  };
